/*
    対策の承認コンポーネント
*/
import React, {
  useRef,
  useEffect,
  RefObject,
  useState,
  createRef,
} from "react";
import { useDispatch, useSelector } from "react-redux";
import { AppDispatch, RootState } from "../../redux/store";
import {
  fetchDefectReportAttachements,
  deleteDefectReportAttachement,
} from "../../redux/defectReportAttachementSlice";
import {
  setReviewComment,
  setRootCause,
  setCorrectiveAction,
  postDefectsReportReviews,
  initApproval,
} from "../../redux/defectsListSlice";
import Carousel from "react-material-ui-carousel";
import "./DefectsApproval.css";
import RippleButton from "../ui/rippleButton";

import { stringDateFormat } from "../../utils/utils";

import Modal from "../ui/Modal";
import ModalConfirm from "../ui/ModalConfirm";

import { GridApi } from "ag-grid-enterprise";

interface DefectsConfirmProps {
  index: number;
  gridApi: GridApi<any> | null;
}

const DefectsConfirm: React.FC<DefectsConfirmProps> = (props) => {
  const dispatch: AppDispatch = useDispatch();
  const memberId = useSelector(
    (state: RootState) => state.user.userInfo.member_id
  );
  const original_member = useSelector(
    (state: RootState) => state.member.original_member
  );

  const defectsList = useSelector((state: RootState) => state.defectsList.rows);
  // 入力エラーメッセージ
  const inputErrors = useSelector(
    (state: RootState) => state.defectsList.inputErrors
  );
  const errorMessage = inputErrors.map((d) => {
    return <div className="defects-approval-errors">{d}</div>;
  });

  const comment = useSelector((state: RootState) => state.defectsList.comment);
  const rootCause = useSelector(
    (state: RootState) => state.defectsList.root_cause
  );
  const correctiveAction = useSelector(
    (state: RootState) => state.defectsList.corrective_action
  );
  const defectReportAttachements = useSelector(
    (state: RootState) => state.defectReportAttachement.defectReportAttachements
  );
  const level1ReviewerNames = useSelector(
    (state: RootState) => state.defectsList.level1ReviewerNames
  ).join(", ");
  const level2ReviewerNames = useSelector(
    (state: RootState) => state.defectsList.level2ReviewerNames
  ).join(", ");
  const level1State = useSelector(
    (state: RootState) => state.defectsList.level1State
  );
  const level2State = useSelector(
    (state: RootState) => state.defectsList.level2State
  );
  const level1ReviewerIds = useSelector(
    (state: RootState) => state.defectsList.level1ReviewerIds
  );
  const level2ReviewerIds = useSelector(
    (state: RootState) => state.defectsList.level2ReviewerIds
  );
  const getReviewLevel = (
    memberId: string,
    level1ReviewerIds: string[],
    level2ReviewerIds: string[]
  ) => {
    if (level2ReviewerIds.includes(memberId)) {
      return 2;
    }
    if (level1ReviewerIds.includes(memberId)) {
      return 1;
    }
    return 0;
  };
  const reviewLevel = getReviewLevel(
    memberId,
    level1ReviewerIds,
    level2ReviewerIds
  );

  const [index, setIndex] = useState(props.index);

  // 作業者名はworker_idからAPI memberで取得したリストを検索して取得する
  const memberNames = original_member.filter(
    (d) => d.member_id === defectsList[index].worker_id
  );
  let memberName: string = "";
  if (memberNames.length > 0) {
    memberName = memberNames[0].name;
  }

  // 不良画像の取得
  const getDefectReports = (index: number) => {
    dispatch(
      fetchDefectReportAttachements(
        defectsList[index].po_data_num,
        defectsList[index].po_desc_num,
        defectsList[index].mach_seq,
        defectsList[index].failure_count,
        defectsList[index].defect_type_seq
      )
    );
  };

  useEffect(() => {
    // 不良情報切り替え時に不良画像を取得
    getDefectReports(index);
  }, [index]);

  // 前のDefectsDetailを表示(フィルタをかけたデータを対象とする)
  const handleBefore = async () => {
    console.log("handleBefore" + index);
    let beforeId = -1;
    let first = true;
    props.gridApi?.forEachNodeAfterFilter((d, filterIndex) => {
      if (d.data.id === index && filterIndex > 0) {
        setIndex(beforeId);
        dispatch(initApproval(defectsList[beforeId]));
        first = false;
      }
      beforeId = d.data.id;
    });
    // 先頭で戻るボタンを押下した場合、フィルタの最後尾に移動
    if (first) {
      setIndex(beforeId);
      dispatch(initApproval(defectsList[beforeId]));
    }
  };

  // 後ろのDefectsDetailを表示(フィルタをかけたデータを対象とする)
  const handleAfter = async () => {
    console.log("handleAfter" + index);

    let findIndex = 0;
    let findId = 0;
    props.gridApi?.forEachNodeAfterFilter((d, filterIndex) => {
      // 先頭のIDを保存（最後の行から次に進む場合は先頭へ戻るため）
      if (filterIndex === 0) {
        findId = d.data.id;
      }
      // ボタン押下した行が見つかった
      if (d.data.id === index) {
        findIndex = filterIndex;
      }
      // ボタン押下した行のindex+1の場合は次の遷移先
      if (filterIndex === findIndex + 1) {
        findId = d.data.id;
      }
    });

    setIndex(findId);
    dispatch(initApproval(defectsList[findId]));
  };

  // 原因の入力
  const handleRootCauseChange = (e: React.ChangeEvent<HTMLTextAreaElement>) => {
    dispatch(setRootCause(e.target.value));
  };
  // 対策の入力
  const handleCorrectiveActionChange = (
    e: React.ChangeEvent<HTMLTextAreaElement>
  ) => {
    dispatch(setCorrectiveAction(e.target.value));
  };
  // コメントの入力
  const handleCommentChange = (e: React.ChangeEvent<HTMLTextAreaElement>) => {
    dispatch(setReviewComment(e.target.value));
  };

  // 承認
  const handleApproval = () => {
    dispatch(
      postDefectsReportReviews(
        index,
        defectsList[index],
        "approve",
        comment,
        rootCause,
        correctiveAction,
        memberId,
        reviewLevel
      )
    );
  };

  // 差し戻し
  const handleReject = () => {
    dispatch(
      postDefectsReportReviews(
        index,
        defectsList[index],
        "reject",
        comment,
        rootCause,
        correctiveAction,
        memberId,
        reviewLevel
      )
    );
  };

  // 画像削除確認モーダル制御
  const [isImageDeleteModalOpen, setIsImageDeleteModalOpen] = useState(false);

  // 画像削除
  const [deleteImageIndex, setDeleteImageIndex] = useState(0);
  const handleImageRemove = (index: number) => {
    setDeleteImageIndex(index);
    setIsImageDeleteModalOpen(true);
  };

  // 画像削除確認モーダル制御

  const closeImageDeleteModal = () => {
    setIsImageDeleteModalOpen(false);
  };
  const applyImageDelete = () => {
    console.log("イメージ削除API実行");
    dispatch(
      deleteDefectReportAttachement(
        defectReportAttachements[0].files[deleteImageIndex].key
      )
    );

    setIsImageDeleteModalOpen(false);
  };

  // 承認履歴
  const review_history = defectsList[index].review_history
    .filter((d) => d.comments !== "")
    .sort((a, b) => (a.review_seq > b.review_seq ? 1 : -1))
    .map((review) => {
      return (
        <div className="defects-history-item">
          <div className="text-h5">{stringDateFormat(review.update_at)}</div>
          <div className="text-h5">
            {review.reviewer_level === 1 && <div>１次承認者</div>}
            {review.reviewer_level === 2 && <div>２次承認者</div>}
          </div>
          <div className="text-h5">
            {review.review_status === "pending" && (
              <img src="images/pending.svg" alt="保留" />
            )}
            {review.review_status === "approved" && (
              <img src="images/approved.svg" alt="承認" />
            )}
            {review.review_status === "rejected" && (
              <img src="images/unapproved.svg" alt="却下" />
            )}
          </div>
          <div className="text-h5">{review.reviewer_name}</div>
          <textarea
            className="defects-comfirm-history-comment-textarea text-h5"
            readOnly={true}
            value={review.comments}
          ></textarea>
        </div>
      );
    });

  // カルーセルに配置するCanvasを作成
  const [previewImages, setPreviewImages] = useState<JSX.Element[]>([]);
  const canvasRefs = useRef<RefObject<HTMLCanvasElement>[]>([]);
  const createCanvas = () => {
    canvasRefs.current = [];
    if (defectReportAttachements.length > 0) {
      // このコンポーネントではDefectReportsは0件または1件のみ存在する想定
      defectReportAttachements.forEach((defectsReport) => {
        const newImages = defectsReport.files.map((element, index: number) => {
          canvasRefs.current[index] = createRef<HTMLCanvasElement>();
          return (
            <div className="defects-images-container">
              <div className="canvas-div"></div>
              <div className="canvas-center-div">
                <div className="defects_preview">
                  <img
                    src="images/delete-button.svg"
                    alt=""
                    className={"defects-icon imade-delete terash "}
                    onClick={() => handleImageRemove(index)}
                  />
                  <canvas
                    width={640}
                    height={360}
                    className="defects-comfirm-preview-canvas"
                    ref={canvasRefs.current[index]}
                  ></canvas>
                </div>
              </div>
              <div className="canvas-div"></div>
            </div>
          );
        });
        setPreviewImages(newImages);
      });
    } else {
      // 画像0件の場合はクリア処理
      setPreviewImages([]);
    }
  };

  // Canvasにイメージをセット
  const setImages = () => {
    canvasRefs.current.forEach((element, index) => {
      if (element.current != null) {
        let ctx = element.current.getContext("2d");
        let img = new Image();
        img.src =
          defectReportAttachements[defectReportAttachements.length - 1].files[
            index
          ].base64_value;
        img.onload = function () {
          if (ctx != null) {
            const afterHeight: number = Math.floor(
              img.height * (640 / img.width)
            );
            if (afterHeight > 360) {
              const afterWidth: number = Math.floor(640 * (360 / afterHeight));
              const startX = (640 - afterWidth) / 2;
              ctx.drawImage(img, startX, 0, afterWidth, 360);
            } else {
              ctx.drawImage(img, 0, 0, 640, afterHeight);
            }
          }
        };
      }
    });
  };

  // Canvasを再作成
  useEffect(() => {
    createCanvas();
  }, [defectReportAttachements]);

  // Canvasにイメージをセット
  useEffect(() => {
    console.log("Canvasにイメージをセット");
    setImages();
  }, [previewImages]);

  return (
    <>
      <RippleButton
        width={"48px"}
        heihgt={"48px"}
        borderRadius={"50%"}
        onClick={handleAfter}
        effectSize={160}
        effectColor={"#000000"}
        className="defects-change-right-button"
      >
        <img
          src="../images/right-arrow.svg"
          alt="次へ"
          className="defects-icon"
        />
      </RippleButton>
      <RippleButton
        width={"48px"}
        heihgt={"48px"}
        borderRadius={"50%"}
        onClick={handleBefore}
        effectSize={160}
        effectColor={"#000000"}
        className="defects-change-left-button"
      >
        <img
          src="../images/left-arrow.svg"
          alt="前へ"
          className="defects-icon"
        />
      </RippleButton>
      {/* タイトル */}
      <div className="title-container">
        <div className="secondary text-weight-bold text-h4">対策の承認</div>
      </div>
      <div className="defects-comfirm-container">
        {/* 不良情報切り替え<ボタン */}
        <div className="defects-left-item"></div>
        {/* 不良情報切り替え>ボタン */}
        <div className="defects-right-itemq"></div>
        <div className="defects-comfirm-status-label-item defects-comfirm-label text-h5 text-weight-bold">
          ステータス
        </div>
        <div className="defects-comfirm-status-item defects-comfirm-status">
          <div className="text-h5">１次承認者</div>
          {level1State === "pending" && (
            <img src="images/pending.svg" alt="保留" />
          )}
          {level1State === "approved" && (
            <img src="images/approved.svg" alt="承認" />
          )}
          {level1State === "rejected" && (
            <img src="images/unapproved.svg" alt="却下" />
          )}
          <div className="text-h5 defects-reviewer-names">
            {level1ReviewerNames}
          </div>
          <div className="text-h5 ">２次承認者</div>
          {level2State === "pending" && (
            <img src="images/pending.svg" alt="保留" />
          )}
          {level2State === "approved" && (
            <img src="images/approved.svg" alt="承認" />
          )}
          {level2State === "rejected" && (
            <img src="images/unapproved.svg" alt="却下" />
          )}
          <div className="text-h5 defects-reviewer-names">
            {level2ReviewerNames}
          </div>
        </div>
        {/* 不良情報 */}
        <div className="defects-comfirm-detail-label-item defects-comfirm-label text-h5 text-weight-bold">
          不良詳細
        </div>
        <div className="defects-comfirm-info-items">
          <div className="defects-comfirm-info-item">
            <label htmlFor="accrual-date">発生日</label>
            <input
              id="accrual-date"
              name="accrual-date"
              type="text"
              readOnly
              value={stringDateFormat(defectsList[index].created_at)}
            />
          </div>
          <div className="defects-comfirm-info-item">
            <label htmlFor="orderno">受注NO</label>
            <input
              id="orderno"
              name="orderno"
              type="text"
              readOnly
              value={defectsList[index].po_desc_num}
            />
          </div>
          <div className="defects-comfirm-info-item">
            <label htmlFor="product-name">商品名</label>
            <input
              id="product-name"
              name="product-name"
              type="text"
              readOnly
              value={defectsList[index].product_name}
            />
          </div>
          <div className="defects-comfirm-info-item">
            <label htmlFor="order-dim">寸法</label>
            <input
              id="order-dim"
              name="order-dim"
              type="text"
              readOnly
              value={
                defectsList[index].order_dim_w !== null
                  ? `${defectsList[index].order_dim_w} × ${defectsList[index].order_dim_h}`
                  : ""
              }
            />
          </div>

          <div className="defects-comfirm-info-item">
            <label htmlFor="registering-proc-name">発見工程</label>
            <input
              id="registering-proc-name"
              name="registering-proc-name"
              type="text"
              readOnly
              value={defectsList[index].registering_proc_name}
            />
          </div>
          <div className="defects-comfirm-info-item">
            <label htmlFor="machCode">機械</label>
            <input
              id="machCode"
              name="machCode"
              type="text"
              readOnly
              value={defectsList[index].registering_mach_name}
            />
          </div>
          <div className="defects-comfirm-info-item">
            <label htmlFor="detection-timing-id">加工の前後</label>
            <input
              id="detection-timing-id"
              name="detection-timing-id"
              type="text"
              readOnly
              value={
                defectsList[index].detection_timing_id === 1
                  ? "前/Before"
                  : "後/After"
              }
            />
          </div>
          <div className="defects-comfirm-info-item">
            <label htmlFor="member-id">作業者</label>
            <input
              id="member-id"
              name="member-id"
              type="text"
              readOnly
              value={memberName}
            />
          </div>

          <div className="defects-comfirm-info-item">
            <label htmlFor="occurred-proc-name">発生加工</label>
            <input
              id="occurred-proc-name"
              name="occurred-proc-name"
              type="text"
              readOnly
              value={defectsList[index].occurred_proc_name}
            />
          </div>
          <div className="defects-comfirm-info-item">
            <label htmlFor="occurred-mach-name">発生機械</label>
            <input
              id="occurred-mach-name"
              name="occurred-mach-name"
              type="text"
              readOnly
              value={defectsList[index].occurred_mach_name}
            />
          </div>
          <div className="defects-comfirm-info-item">
            <label htmlFor="order-qty">計画数</label>
            <input
              id="order-qty"
              name="order-qty"
              type="text"
              readOnly
              value={defectsList[index].order_qty}
            />
          </div>
          <div className="defects-comfirm-info-item">
            <label htmlFor="scrap-qty">不良品数</label>
            <input
              id="scrap-qty"
              name="scrap-qty"
              type="text"
              readOnly
              value={defectsList[index].scrap_qty}
            />
          </div>
          <div className="defects-comfirm-info-item">
            <label htmlFor="defect-type">不良品理由</label>
            <input
              id="defect-type"
              name="defect-type"
              type="text"
              readOnly
              value={defectsList[index].defect_type}
            />
          </div>
        </div>
        {/* 不良画像カルーセル */}
        <div
          className="defects-image-item"
          style={{ display: previewImages.length > 0 ? "block" : "none" }}
        >
          <Carousel autoPlay={false} navButtonsAlwaysVisible={true}>
            {previewImages}
          </Carousel>
        </div>
        <div
          className="defects-image-empty-ite1m"
          style={{ display: previewImages.length === 0 ? "block" : "none" }}
        ></div>
        <div className="defects-cause-item">
          <div className="defects-comfirm-cause-label text-h5">発生原因</div>
          <textarea
            className="defects-comfirm-cause-textarea text-h5"
            value={rootCause}
            onChange={handleRootCauseChange}
          ></textarea>
          <div className="defects-comfirm-countermeasure-label text-h5">
            対策
          </div>
          <textarea
            className="defects-comfirm-countermeasure-textarea text-h5"
            value={correctiveAction}
            onChange={handleCorrectiveActionChange}
          ></textarea>
        </div>
        <div className="defects-line-item">
          <hr className="defects-border"></hr>
        </div>
        {/* 承認履歴 */}
        <div className="defects-comment-histry-label-item defects-comfirm-label text-h5 text-weight-bold">
          {review_history.length > 0 && "承認履歴"}
        </div>
        <div className="defects-comment-history-item">
          {review_history.length > 0 && (
            <div className="defects-comment-history-container">
              {review_history}
            </div>
          )}
        </div>
        <div className="defects-comment-item">
          {reviewLevel > 0 && (
            <div className="defects-comfirm-comment-label text-h5">
              コメント
            </div>
          )}
          {reviewLevel > 0 && (
            <textarea
              className="defects-comfirm-comment-textarea text-h5"
              value={comment}
              onChange={handleCommentChange}
            ></textarea>
          )}
        </div>
        <div className="defects-comfirm-errors-item text-h5">
          {errorMessage}
        </div>
        <div className="defects-button-item">
          {reviewLevel > 0 && (
            <RippleButton
              width={"200px"}
              heihgt={"62px"}
              borderRadius={"8px"}
              onClick={handleApproval}
              effectSize={160}
              className="bk-secondary"
            >
              <span className="children">承認</span>
            </RippleButton>
          )}
          {reviewLevel > 0 && (
            <RippleButton
              width={"200px"}
              heihgt={"62px"}
              borderRadius={"8px"}
              onClick={handleReject}
              effectSize={160}
              className="bk-positive"
            >
              <span className="children">差し戻し</span>
            </RippleButton>
          )}
        </div>
      </div>

      {/* 画像削除確認モーダル */}
      <Modal
        isOpen={isImageDeleteModalOpen}
        onClose={closeImageDeleteModal}
        width="640px"
        height="240px"
        contentClassName={""}
      >
        <ModalConfirm
          onApply={applyImageDelete}
          onCancel={closeImageDeleteModal}
          title={"画像削除の確認"}
          message={
            "画像を削除すると元に戻せません。削除してよろしいでしょうか?"
          }
          applyButtonMessage={"Apply"}
          cancelButtonMessage={"Cancel"}
        ></ModalConfirm>
      </Modal>
    </>
  );
};

export default DefectsConfirm;
